<div class="d-flex align-items-center justify-content-between px-4 pt-4 px-md-8 pt-md-8">
  <h1 class="semi-bold">Continue to your account</h1>

  <ds-button
    (click)="hideModal.emit()"
    variant="icon"
    size="s"
    icon="xmark"
    label="Close"
    class="d-none d-md-inline"
    data-id="hide"
  />
</div>

<p class="mt-2 mx-4 mx-md-8">
  Get better deals, save your details for easy booking, and see all your trips in one place.
</p>

<div class="d-flex flex-column mx-4 mx-md-8 mb-4 mb-md-8">
  <ds-button
    (click)="continueWithGoogle.emit()"
    [attr.data-redirect-url]="currentUrl"
    variant="secondary"
    leadingIcon="google"
    label="Continue with Google"
    [fullWidth]="true"
    class="mt-8"
    data-id="google"
  />

  <ds-button
    (click)="continueWithFacebook.emit()"
    variant="secondary"
    leadingIcon="facebook"
    label="Continue with Facebook"
    [fullWidth]="true"
    class="mt-4"
    data-id="facebook"
  />

  <ds-button
    (click)="continueWithEmail.emit()"
    variant="secondary"
    leadingIcon="envelope"
    label="Continue with Email"
    [fullWidth]="true"
    class="mt-4"
    data-id="email"
  />
</div>
